import { useQuery } from '@tanstack/react-query';
import { profileService } from '@/shared/api/services/profile.service';
import { cacheKeys } from '@/shared/lib/cache-invalidation';
import type { SignInState } from '@/types/profile';
import { useAuthStore } from './auth.store';

/**
 * The server's `sign_in` block (docs/identity/ADR-001 §5): the account's
 * sign-in methods and whether to suggest or require adding one. Seeded from
 * every profile payload by `applyProfileData`; read verbatim.
 */
export function useSignInState(): SignInState | undefined {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { data } = useQuery({
    queryKey: cacheKeys.signIn,
    queryFn: async () => (await profileService.fetchProfile()).sign_in ?? null,
    enabled: isAuthenticated,
  });
  return data ?? undefined;
}
